/** @type {Record<import("utils/types").TextType, boolean>} */
export const SUPPORTED_TEXT_TYPES = {
  h1: true,
  h2: true,
  h3: true,
  h4: true,
  p: true,
  span: true
};
